<template>
  <v-ons-page>
    <v-ons-toolbar modifier="transparent"></v-ons-toolbar>
    <!-- <div class="header">
      <img src="../assets/miley_logo_white_40px.png">
    </div> -->

    <!-- <v-ons-list-title>メイン機能</v-ons-list-title>
    <v-ons-list>
      <v-ons-list-item modifier="chevron" v-for="item in mainLinks" @click="goToTabs(item)" :key="item.index">
        <div class="left"><v-ons-icon fixed-width :icon="item.icon"></v-ons-icon></div>
        <div class="center">{{ item.label }}</div>
      </v-ons-list-item>
    </v-ons-list> -->

    <v-ons-list-title>サイドメニュー</v-ons-list-title>
    <v-ons-list>
      <v-ons-list-item modifier="chevron" v-for="item in sideMenuList" @click="goToSideComponent(item)" :key="item.link">
        <div class="left"><v-ons-icon style="color: #5D99FF;" fixed-width :icon="item.icon"></v-ons-icon></div>
        <div class="center"><v-ons-button modifier="quiet" :class="{badge2: item.badge}" data-badge=" ">{{ item.label }}</v-ons-button></div>
        <div class="right"></div>
      </v-ons-list-item>
    </v-ons-list>
  </v-ons-page>
</template>

<script>
export default {
  name: 'SideMenu',
  data () {
    return {
      sideMenus: [
        // {
        //   label: 'アカウント情報',
        //   link: 'AccountRoot',
        //   icon: 'fa-user-cog',
        //   anim: 'slide',
        //   badge: false
        // },
        {
          label: 'ラスメルについて',
          link: 'AboutMileyRoot',
          icon: 'fa-smile-wink',
          anim: 'slide',
          badge: false
        }
        // {
        //   label: '開発メニュー',
        //   link: 'DevRoot',
        //   icon: 'fa-thumbs-up',
        //   anim: 'slide',
        //   badge: false
        // }
      ]
    }
  },
  computed: {
    sideMenuList: {
      get () {
        return this.sideMenus
      }
    }
  },
  methods: {
    goToSideComponent (item) {
      if (item.anim !== 'none') {
        this.$store.commit('splitter/toggle') // splitterを閉じる
        this.$store.commit('toolbar/set', item.label)
        this.$store.commit('routerAnim/set', item.anim)

        this.$router.push({name: item.link})
      }
    },
    goToTabs (item) {
      if (item.anim !== 'none') {
        this.$store.commit('splitter/toggle') // splitterを閉じる
        this.$store.commit('toolbar/set', item.label)
        this.$store.commit('routerAnim/set', item.anim)
        this.$store.commit('tabbar/set', item.index)
        this.$router.push({name: item.link})
      }
    }
  }
}
</script>

<style scoped>
@import "../../src/assets/css/miley.css";

.header {
  text-align: center;
  margin-bottom: 20px;
}

img {
  max-width: 150px;
}

ons-list-title {
  text-transform: none;
}

ons-list-item {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/MenuPage.vue